<template>
  <div class="mb-8">
    <v-card class="mx-auto mb-3">
      <div id="filters">
        <template>
          <v-toolbar flat>
            <v-toolbar-title>
              <p class="mb-0">{{ $t("APPROVAL_RULES") }}</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="d-flex align-center justify-space-between">
              <v-btn
                  :disabled="cannotAddNewRule"
                  color="secondary"
                  dark
                  @click="dialog = true"
              >
                {{ $t("ADD_NEW") }}
              </v-btn>
            </div>
          </v-toolbar>
          <v-form ref="filterForm">
            <v-container>
              <v-row>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12">
                  <v-select
                      v-model="filterItems.yearId"
                      :item-text="y => $t(y.name)"
                      :items="years"
                      :label="$t('ACADEMIC_YEAR')"
                      item-value="id"
                      outlined
                      @change="changeYear"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" xs="12">
                  <v-select
                      v-model="filterItems.semesterId"
                      :item-text="y => serverTranslate(y.name)"
                      :items="semesters"
                      :label="$t('ACADEMIC_SEMESTER')"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions class="px-4">
              <v-container class="px-0">
                <v-row>
                  <v-col class="pa-1" cols="auto">

                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        class="mx-2"
                        color="primary"
                        @click="showScopeTreeFn()">
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('SCOPE') }}</span>
                      <v-icon :right="$vuetify.breakpoint.mdAndUp">mdi-navigation</v-icon>
                    </v-btn>
                  </v-col>

                  <v-spacer></v-spacer>
                  <v-col class="pa-1" cols="auto">
                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        color="primary" dark @click="searchApprovalRules"
                    >
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t("SEARCH") }}</span>
                      <v-icon :right="$vuetify.breakpoint.mdAndUp">mdi-account-search</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col class="pa-1 mx-2" cols="auto">
                    <v-btn
                        :fab="!$vuetify.breakpoint.mdAndUp"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        class="white--text"
                        color="darken3"
                        @click="resetFilters"
                    >
                      <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t("RESET") }}</span>
                      <v-icon :right="$vuetify.breakpoint.mdAndUp">mdi-delete-empty</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-form>
        </template>
      </div>
    </v-card>
    <v-card class="mx-auto" outlined>
      <div id="inspire">
        <v-data-table
            :footer-props="{
         showFirstLastPage: true,
         firstIcon: 'mdi-arrow-collapse-left',
         lastIcon: 'mdi-arrow-collapse-right',
         prevIcon: 'mdi-arrow-left',
         nextIcon: 'mdi-arrow-right',
         itemsPerPageOptions: [5, 10, 15, 50, 100]
         }"
            :headers="headers"
            :hide-default-footer="approvalRules.length <= 0"
            :items="approvalRules"
            :items-per-page="5"
            :loading="loading"
            class="elevation-1"
        >
          <template v-slot:item.facultyName="{ item }">
            {{ serverTranslate(item.facultyName) }}
          </template>
          <template v-slot:item.certificateName="{ item }">
            {{ serverTranslate(item.certificateName) }}
          </template>
          <template v-slot:item.priorityCheck="{ item }">
            {{ (item.priorityCheck === 0 ? $t('FIRST_APPLY') : (item.priorityCheck === 1 ? $t('LARGEST_TOTAL') : '')) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip v-if="item.studentsInBranches.length" top>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="showBranchsTotalCount(item)" v-on="on">
                  <v-icon class="mx-2" color="primary" meduim>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("STUDENTS_COUNT_IN_BRANCH") }}</span>
            </v-tooltip>
            <template v-if="item.facultyActivation === 1"
            >
              <v-tooltip v-if="item.yearId == activeAcademicYear.id && item.semesterId == activeAcademicSemester.id
               " top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="editApprovalRule(item)" v-on="on">
                    <v-icon class="mx-2" meduim>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("EDIT") }}</span>
              </v-tooltip>
              <v-tooltip v-if="item.recommendedAccepted == 0 && item.recommendedRefused == 0" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                      color="error"
                      icon
                      @click="deleteApprovalRule(item)"
                      v-on="on"
                  >
                    <v-icon class="mx-2" meduim>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("DELETE") }}</span>
              </v-tooltip>
            </template>
            <v-tooltip v-else top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon class="mx-2" meduim>mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("INACTIVE_FACULTY") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-alert class="mt-2" color="light5" icon="warning">
              {{ $t("NO_DATA") }}
            </v-alert>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-item v-html="gridTitle"></v-toolbar-item>
            </v-toolbar>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <pr-confirmDialog ref="confirm"></pr-confirmDialog>

    <!-- add new rule -->
    <v-dialog
        v-model="dialog"
        max-width="90vh"
        @keydown.esc="reset()"
        @click:outside="reset()"
    >
      <v-card outlined>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title class="justify-center">
         <span class="headline black--text text-thin">{{
             $t(formTitle)
           }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-alert v-show="showAlert" outlined type="error">
                {{ serverTranslate(errorMessages) }}
              </v-alert>
                 <v-row>
                <v-col cols="6">
                  {{ $t("ACADEMIC_YEAR") }} :
                  <v-chip class="ma-2" color="dark" dark>
                    {{ serverTranslate(filterItems.yearName || "") }}
                  </v-chip>
                </v-col>
                <v-col cols="6">
                  {{ $t("ACADEMIC_SEMESTER") }} :
                  <v-chip class="ma-2" color="dark" dark>
                    {{ serverTranslate(filterItems.semesterName || "") }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-select
                      v-if="isAddEvent"
                      ref="faculty"
                      v-model="facultyId"
                      :items="serverTranslateArray(faculties, 'name')"
                      :label="$t('FACULTY')"
                      :rules="requiredRules"
                      item-text="name"
                      item-value="id"
                      required
                      @change="
                  branchesNumbers = [];
                  branchesNumbersModel = [];
                  "
                      @keydown.space="preventLeadingSpace"
                  ></v-select>
                  <v-chip v-else label>
                    {{ serverTranslate(facultyName) }}
                  </v-chip>
                </v-col>

                <v-col cols="12">
                  <v-select
                      v-if="isAddEvent"
                      ref="faculty"
                      v-model="certificateId"
                      :items="serverTranslateArray(CertificateBasicTypes, 'name')"
                      :label="$t('CERTIFICATE_TYPE')"
                      :rules="requiredRules"
                      item-text="name"
                      item-value="admissionId"
                      required
                      @change="
                  branchesNumbers = [];
                  branchesNumbersModel = [];
                  "
                      @keydown.space="preventLeadingSpace"
                  ></v-select>
                  <v-chip v-else label>
                    {{ serverTranslate(certificateName) }}
                  </v-chip>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      ref="totalDegree"
                      v-model="totalDegree"
                      :label="$t('MINIMUM_TOTAL_DEGREE')"
                      :rules="totalRules"
                      clearable
                      @input="totalDegree = parseFloat($event) || null"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      v-if="checkBranches"
                      ref="studentsNumbersTotal"
                      v-model="studentsCount"
                      :disabled="checkBranches"
                      :label="$t('STUDENTS_NUMBERS')"
                      :rules="studentsNumbersRules"
                      clearable
                      @input="studentsNumbers = parseInt($event) || null"
                  />
                  <v-text-field
                      v-else
                      v-model="studentsCount"
                      :label="$t('STUDENTS_NUMBERS')"
                      :rules="studentsNumbersRules"
                      clearable
                  />
                </v-col>
              </v-row>
              <v-row v-if="isAddEvent">
                <v-col
                    v-for="(branch, index) in branchesComputed"
                    v-bind:key="index"
                    cols="12"
                >
                  <v-text-field
                      :ref="'branchesNumbers_' + branch.id"
                      v-model="branchesNumbersModel[branch.id]"
                      :label="
               $t('STUDENTS_NUMBERS_FOR') + serverTranslate(branch.name)
               "
                      :rules="branchesNumbersRules"
                      clearable
                      @input="updateBranchesNumbers(branch.id, $event)"
                  />
                </v-col>
              </v-row>
              <v-row v-if="!isAddEvent">
                <v-col
                    v-for="(item,index) in editRule.studentsInBranches"
                    v-bind:key="index"
                    cols="12"
                >
                  <v-text-field
                      :ref="'editBranchesNumbers_' + item.branchId"
                      v-model="item.studentsNumbers"
                      :label="
            $t('STUDENTS_NUMBERS_FOR') + serverTranslate(item.branchName)
            "
                      :rules="branchesNumbersRules"
                      clearable
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  {{ $t('PERIORITY') }}:
                  <v-radio-group
                      v-model="priorityCheck"
                      :rules="requiredRules"
                      column>
                    <v-radio
                        :label="$t('LARGEST_TOTAL')"
                        color="blue"
                        value=1
                    ></v-radio>
                    <v-radio
                        :label="$t('FIRST_APPLY')"
                        color="blue"
                        value=0
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="save">{{ $t("SAVE") }}</v-btn>
            <v-btn class="white--text" color="darken3" @click="reset()">
              {{ $t("CANCEL") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>


    <pr-scope
        v-if="showScopeTree == true"
        :key="componentKey"
        :scopeFullPath="false"
        v-on:setScope="onScopeChanged"
    />
    <pr-students-branches-dialog
        v-if="showBranchesCount"
        :key="branchKey"
        :branches="studentsInBranches"
        :faculty="faculty"
    />
  </div>
</template>

<script>
import serverTranslations from "@/mixins/serverTranslations";
import scope from "@/components/shared/ScopeTree.vue";
import branchesDialog from "./BranchesDialog.vue";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import globalMethods from "@/mixins/globalMethods";

export default {
  name: "List",
  components: {
    "pr-scope": scope,
    "pr-students-branches-dialog": branchesDialog,
    "pr-confirmDialog": ConfirmDialog
  },
  mixins: [serverTranslations, globalMethods],
  mounted() {
    this.getApprovalRules();
  },
  computed: {
    studentsNumbers() {
      let total = 0;
      if (!this.isAddEvent && this.editRule.studentsInBranches && this.checkBranches) {
        this.editRule.studentsInBranches.forEach(item => {
          item.studentsNumbers = item.studentsNumbers ? item.studentsNumbers : 0;
          total += parseInt(item.studentsNumbers);
          item.studentsNumbers = item.studentsNumbers ? item.studentsNumbers : '';
        });
      } else if (this.isAddEvent && this.branchesNumbersModel && this.checkBranches) {
        this.branchesNumbersModel.forEach(item => {
          item = item ? item : 0;
          total += parseInt(item);
        });
      } else if (!this.checkBranches) {

        total = this.studentsNumbers


      }
      return total;
    },
    locale() {
      return this.$store.curLanguage;
    },
    activeAcademicYear() {
      return this.$store.getters.getActiveAcademicYear;
    },
    activeAcademicSemester() {
      return this.$store.getters.getActiveAcademicSemester;
    },
    gridTitle() {
      const year = this.serverTranslate(this.filterItems.yearName ?? "");
      const semester = this.serverTranslate(
          this.filterItems.semesterName ?? ""
      );

      return this.$t("APPROVAL_RULES_GRID_TITLE", {
        year: `<bdi>${year}</bdi>`,
        semester
      });
    },
    formTitle() {
      return this.isAddEvent ? "ADD_APPROVAL_RULE" : "EDIT_APPROVAL_RULE";
    },
    headers() {
      return [
        {
          text: this.$t("FACULTY"),
          align: "center",
          sortable: true,
          value: "facultyName",
          width: "45%"
        },
        {
          text: this.$t("TOTAL_DEGREE"),
          align: "center",
          sortable: true,
          value: "allowedTotalDegree",
          width: "10%"
        },
        {
          text: this.$t("CERTIFICATE_TYPE"),
          align: "center",
          sortable: true,
          value: "certificateName",
          width: "10%"
        }, {
          text: this.$t("STUDENTS_NUMBERS"),
          align: "center",
          sortable: true,
          value: "allowedStudentCount",
          width: "10%"
        },
        {
          text: this.$t("PERIORITY"),
          align: "center",
          sortable: true,
          value: "priorityCheck",
          width: "10%"
        },
        {
          text: this.$t("RECOMMENDED_ACCEPTED"),
          align: "center",
          sortable: true,
          value: "recommendedAccepted",
          width: "10%"
        },
        {
          text: this.$t("RECOMMENDED_REFUSED"),
          align: "center",
          sortable: true,
          value: "recommendedRefused"
        },
        {
          text: this.$t("RULE_APPLY_DATE"),
          align: "center",
          value: "ruleApplyDate",
          sortable: false,
        },
        {
          text: this.$t("ACTIONS"),
          value: "actions",
          sortable: false,
          width: "20%"
        }
      ];
    },
    cannotAddNewRule() {
      const activeSemesters = this.semesters.filter(
          semester => parseInt(semester.active) === 1
      );
      return !(activeSemesters.length > 0);
    },
    branchesComputed() {
      if (this.branches,length>0){
         return this.branches.filter(
          branch => branch.faculty_id === this.facultyId
      );
      }
      else return [];

    }
  },

  data() {
    return {
      priorityCheck: "1",
      total: 0,
      valid: true,
      dialog: false,
      loading: false,
      checkBranches: true,
      showAlert: false,
      errorMessages: "",
      filterItems: {
        facultyId: 0,
        yearId: 0,
        yearName: "",
        semesterId: 0,
        semesterName: ""
      },
      semesters: [],
      years: [],
      scopes: [],
      faculties: [],
      CertificateBasicTypes: [],
      branches: [],/*Contains all define branches categorized by faculty_id*/
      approvalRules: [],/*all defined rules with student numbers in each branch*/
      editRule: {},
      currentYear: {},
      currentSemester: {},
      facultyId: 0,
      certificateId: 0,
      facultyName: "",
      certificateName: "",
      universityId: 0,
      totalDegree: null,
      studentsCount: 0,
      // studentsNumbers: null,
      branchesNumbers: [],
      branchesNumbersModel: [],
      yearId: 0,
      yearName: "",
      semesterId: 0,
      semesterName: "",
      isAddEvent: true,
      requiredRules: this.$store.state.Rules.requiredRules,
      studentsNumbersRules: this.$store.state.Rules.studentsNumbersRules,
      branchesNumbersRules: [
        v => this.isNotEmpty(v) || this.$t("REQUIRED_FIELD"),
        v =>
            this.isNotEmpty(v)
                ? /^(?:[1-9]\d*|0)?(?:\d+)?$/.test(v) || this.$t("INT_NUMBER_FIELD")
                : true,
        v => {
          if (this.isNotEmpty(v)) {
            let branchesNumbers = 0;

            this.branchesNumbers.forEach(branch => {
              branchesNumbers += parseInt(branch.studentsNumbers) || 0;
            });
            return (
                this.studentsNumbers >= branchesNumbers ||
                this.$t("BRANCHES_NUMBERS_MAX")
            );
          }
          return true;
        }
      ],
      totalRules: this.$store.state.Rules.totalRules,

      showScopeTree: false,
      componentKey: 0,
      branchKey: 0,
      showBranchesCount: false,
      studentsInBranches: [],
      faculty: ""
    };
  },

  methods: {
    updateBranchesNumbers(branchId, $event) {
      const index = this.branchesNumbers.findIndex(
          branch => branch.branchId === branchId
      );
      if (index === -1) {
        this.branchesNumbers.push({
          branchId: branchId,
          studentsNumbers: parseInt($event) || null
        });
      } else {
        this.branchesNumbers[index].studentsNumbers = parseInt($event) || null;
      }
    },
    showScopeTreeFn() {
      this.showScopeTree = true;
      this.showBranchesCount = false;
      this.componentKey += 1;
    },
    getApprovalRules(facultyId = null, yearId = null, semesterId = null, certificateId = null) {
      this.loading = true;
      return this.$http
          .post("/api/tansiq/list_allocation_rules/", {
            facultyId: facultyId || "",
            yearId: yearId || this.activeAcademicYear.id || 0,
            semesterId: semesterId || this.activeAcademicSemester.id || 0
          })
          .then(response => {
            const data = response.data.data;
            this.semesters = data.Semesters;
            this.approvalRules = data.approvalRules;
            this.faculties = data.faculties;
            this.CertificateBasicTypes = data.CertificateBasicTypes;
            this.branches = data.branches;
            this.years = data.years;
            this.checkBranches = data.checkBranches
            this.currentYear = this.years.filter(
                year => parseInt(year.active) === 1
            )[0];
            if (!yearId) {
              this.filterItems.yearId = this.currentYear.id || 0;
              this.filterItems.yearName = this.currentYear.name || "";
            } else {
              const year = this.years.find(year => year.id === yearId);
              this.filterItems.yearId = year ? year.id : 0;
              this.filterItems.yearName = year ? year.name : "";
            }

            this.currentSemester = this.semesters.filter(
                semester => parseInt(semester.active) === 1
            )[0];
            if (!semesterId) {
              this.filterItems.semesterId = this.currentSemester.id || 0;
              this.filterItems.semesterName = this.currentSemester.name || "";
            } else {
              const semester = this.semesters.find(
                  semester => semester.id === semesterId
              );
              this.filterItems.semesterId = semester ? semester.id : 0;
              this.filterItems.semesterName = semester ? semester.name : "";
            }
          }).catch(err => {
            this.showToasted('error', err.response?.data?.message || 'Fetch Error');
          })
          .then(() => (this.loading = false));
    },
    isNotEmpty(str) {
      return !(!str || 0 === str.length || /^\s*$/.test(str));
    },
    searchApprovalRules() {
      this.getApprovalRules(
          null,
          this.filterItems.yearId,
          this.filterItems.semesterId
      );
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] === " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    save() {
      if (this.$refs.form.validate()) {
        if (!this.isAddEvent)
          this.branchesNumbers = this.editRule.studentsInBranches.map(item => ({
            branchId: item.branchId,
            studentsNumbers: item.studentsNumbers
          }));
        const data = {}
        data['facultyId'] = this.facultyId
        data['certificateId'] = this.certificateId
        data['yearId'] = this.filterItems.yearId
        data['semesterId'] = this.filterItems.semesterId
        data['totalDegree'] = this.totalDegree
        data['priorityCheck'] = this.priorityCheck
        if (this.checkBranches) {
          data['studentsNumbers'] = this.studentsNumbers
        } else {
          data['studentsNumbers'] = parseInt(this.studentsCount)
        }
        data['branchesNumbers'] = this.branchesNumbers
        const request = this.isAddEvent ? this.$http.post("/api/approval_rules/add_rule/", data)
            : this.$http.put(`/api/approval_rules/edit_rule/${this.editRule.id}/`, data);
        request.then(
            res => {
              this.reset();
              this.showToasted("success", this.$t("APPROVAL_RULE_ADDED"));
              this.filterItems = {
                facultyId: 0,
                certificateId: 0,
                yearId: 0,
                yearName: "",
                semesterId: 0,
                semesterName: ""
              };
              this.getApprovalRules();
              this.$refs.form.reset()
            },
            err => {
              this.showAlert = true;
              this.errorMessages = this.serverTranslate(err.response.data.message);
              if (err.response.status === 404) {
                this.showToasted("error", this.serverTranslate(err.response.data.message));
                this.reset();
                this.getApprovalRules();
              }
            }
        );
      } else {
        this.showAlert = true;
        this.errorMessages = this.showAlert ? this.$t("COMPLETE_DATA_ERROR") : "";
      }
    },
    editApprovalRule(rule) {

      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "CONFIRMATION_UPDATE_RULE")
          .then(confirm => {
            if (confirm) {
              this.editRule = JSON.parse(JSON.stringify(rule)); // for deep copy
              this.totalDegree = this.editRule.allowedTotalDegree;
              this.studentsNumbers = this.editRule.allowedStudentCount;
              this.studentsCount = this.editRule.allowedStudentCount;
              this.facultyId = this.editRule.facultyId;
              this.facultyName = this.editRule.facultyName;
              this.certificateName = this.editRule.certificateName;
              this.priorityCheck = this.editRule.priorityCheck.toString();
              this.isAddEvent = false;
              this.dialog = true
            }
          });

    },
    deleteApprovalRule(rule) {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "CONFIRM_MESSAGES.DELETE_CONFIRMATION")
          .then(res => {
            if (res) {
              this.$http.post(`/api/approval_rules/delete_rule/${rule.id}/`)
                  .then(
                      res => {
                        this.getApprovalRules();
                        this.showToasted("success", res.data.message);
                      },
                      err => {
                        this.showToasted("error", err.response.data.message);
                        this.getApprovalRules();
                      }
                  )
            }
          })

    },
    resetFilters() {
      this.filterItems = {
        facultyId: 0,
        yearId: 0,
        yearName: "",
        semesterId: 0,
        semesterName: ""
      };

      this.getApprovalRules();
    },
    reset() {
      this.dialog = !close;
      this.isAddEvent = true;
      this.showAlert = false;
      this.errorMessages = "";

      this.facultyId = 0;
      this.yearId = 0;
      this.semesterId = 0;
      this.totalDegree = null;
      this.priorityCheck = "1"
      this.studentsNumbers = null;

      this.branchesNumbers = [];
      this.branchesNumbersModel = [];
    },
    onScopeChanged(changed) {
      if (changed)
        this.searchApprovalRules();
    },
    showBranchsTotalCount(item) {
      this.studentsInBranches = this.serverTranslateArray(item.studentsInBranches, "branchName");
      this.showBranchesCount = true;
      this.branchKey += 1;
      this.faculty = this.serverTranslate(item.facultyName);
    }
  },
  watch: {
    'filterItems.yearId'(newId) {
      const selected = this.years.find(y => y.id === newId);
      this.filterItems.yearName = selected ? selected.name : null;
    },
    'filterItems.semesterId'(newId) {
      const selected = this.semesters.find(y => y.id === newId);
      this.filterItems.semesterName = selected ? selected.name : null;
    },
    studentsNumbers(newValue) {
      const totalBranchesNumbers = this.branchesNumbersModel.reduce(
          (a, b) => parseInt(a) + parseInt(b),
          0
      );
      if (newValue >= totalBranchesNumbers) {
        const formInputsRefs = Object.keys(this.$refs);
        formInputsRefs.forEach(input => {
          if ((input || "").startsWith("branchesNumbers")) {
            const inputElement = this.$refs[input][0];
            inputElement.validate();
          }
        });
      }
    }
  }
};


</script>

<style>
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}

table tr th {
  white-space: normal !important;
}

.v-messages__message {
  color: red !important;
}
</style>